import type { AxiosInstance } from 'axios';
import type { MessageTestingRequest, MessageTestingRunInputs } from '../types/message-testing.js';

export class MessageTestingClient {
  constructor(private authenticatedClient: AxiosInstance) {}

  startRun = async (data: MessageTestingRequest): Promise<{ id: number }> => {
    const res = await this.authenticatedClient.post<{ id: number }>('/message-testing', data);
    return res.data;
  };

  getRun = async (id: number): Promise<MessageTestingRunInputs> => {
    const res = await this.authenticatedClient.get<MessageTestingRunInputs>(`/message-testing/${id}`);
    return res.data;
  };

  exportPpt = async (id: number): Promise<Blob> => {
    const res = await this.authenticatedClient.post<Blob>(`/message-testing/${id}/export-ppt`, undefined, {
      responseType: 'blob',
    });
    return res.data;
  };
}
